// extracted by mini-css-extract-plugin
export var contentContainer = "marquee-module--contentContainer--66276";
export var fill = "marquee-module--fill--a36a8";
export var fixed = "marquee-module--fixed--fcd8a";
export var headerCopy = "marquee-module--headerCopy--ada9c";
export var hug = "marquee-module--hug--8dde5";
export var iconContainer = "marquee-module--iconContainer--ff7a5";
export var imageContainer = "marquee-module--imageContainer--476ca";
export var itemContainer = "marquee-module--itemContainer--1908e";
export var itemInner = "marquee-module--itemInner--fdeba";
export var itemsContainer = "marquee-module--itemsContainer--ff1b4";
export var moduleContainer = "marquee-module--moduleContainer--15651";
export var stackItems = "marquee-module--stackItems--6ee3e";
export var svgContainer = "marquee-module--svgContainer--887e7";